export default "/profile/images/NovaTalks.svg?3e4f19e91c3d8d06e677195d58add4a5";